'use client'

import { FunctionComponent, useContext } from 'react'
import BreadCrumb from '../BreadCrumb/Breadcrumb'
import { ConfigContext, useTranslation } from '../../context/ConfigContext'
import { findStoreByLocaleOrPrefix } from '../../../domain/store'

const StoreBreadcrumb: FunctionComponent<{ sellerName: string; locale: string }> = ({
  sellerName,
  locale,
}) => {
  const { storeConfig } = useContext(ConfigContext)
  const t = useTranslation()

  return (
    <BreadCrumb
      breadcrumbs={[
        {
          id: 0,
          name: t('Nos boutiques'),
          url: storeConfig.retailers_alternates.find(
            (retailer) => retailer.language_code === findStoreByLocaleOrPrefix(locale).locale,
          )?.url,
        },
      ]}
      name={sellerName}
    />
  )
}

export default StoreBreadcrumb
